module.exports = __webpack_public_path__ + "img/betsize_btn.67db42d9.png";